/*
 *
 * Chatbot
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 16-Apr-2025
*/

import { connect } from 'react-redux'
import Chatbot from './Chatbot'
import { nullSafe } from 'Utility/globalMethods'
import { doChatBotMounted } from 'Store/actions/chatbot'
import { doSessionActivity } from 'Store/actions/session'

const mapDispatchToProps = (dispatch) => ({
  doChatBotMounted: (bool) => dispatch(doChatBotMounted(bool)),
  doSessionActivity: () => dispatch(doSessionActivity())
})

const mapStateToProps = (state) => ({
  isMounted: nullSafe(() => state.chatbot.isMounted, false),
  isSessionPopupOpen: ['EXTEND_SESSION', 'EXPIRED_SESSION'].includes(state.popup?.popupKey)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(Chatbot)
